import GroupRoundedIcon from '@mui/icons-material/GroupRounded';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import { lazy } from 'react';
import { PERMISSIONS, holdsPermission } from '@/api/permissions';
import { paths } from '@/routes/paths';
import { RequirePermission } from '@/routes/guards';
import type { ModuleManifest } from './manifest';

const UsersPage = lazy(() => import('@/features/users/UsersPage'));
const RolesPage = lazy(() => import('@/features/roles/RolesPage'));

/**
 * Access — people and what each of them may do. Both audiences: every
 * organization owns its own users and its own roles, and platform staff own
 * theirs; the backend scopes the rows.
 */
export const accessModule: ModuleManifest = {
  key: 'access',
  titleKey: 'modules.access.title',
  descriptionKey: 'modules.access.description',
  icon: GroupRoundedIcon,
  prefix: '/access',
  anyOf: [PERMISSIONS.USER_READ, PERMISSIONS.ROLE_READ],
  sections: [
    {
      key: 'access',
      items: [
        {
          key: 'users',
          labelKey: 'nav.users',
          to: paths.users,
          icon: <GroupRoundedIcon />,
          anyOf: [PERMISSIONS.USER_READ],
        },
        {
          key: 'roles',
          labelKey: 'nav.roles',
          to: paths.roles,
          icon: <AdminPanelSettingsRoundedIcon />,
          anyOf: [PERMISSIONS.ROLE_READ],
        },
      ],
    },
  ],
  routes: [
    {
      element: <RequirePermission permission={[PERMISSIONS.USER_READ]} />,
      children: [{ path: paths.users, element: <UsersPage /> }],
    },
    {
      element: <RequirePermission permission={[PERMISSIONS.ROLE_READ]} />,
      children: [{ path: paths.roles, element: <RolesPage /> }],
    },
  ],
  landing: (viewer) =>
    holdsPermission(viewer.permissions, PERMISSIONS.USER_READ) ? paths.users : paths.roles,
};
